var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M6.03333 1.66602H4.45C2.625 1.66602 1.66666 2.62435 1.66666 4.44102V6.02435C1.66666 7.84102 2.625 8.79935 4.44166 8.79935H6.025C7.84166 8.79935 8.8 7.84102 8.8 6.02435V4.44102C8.80833 2.62435 7.85 1.66602 6.03333 1.66602Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    d: "M15.5583 1.66602H13.975C12.1583 1.66602 11.2 2.62435 11.2 4.44102V6.02435C11.2 7.84102 12.1583 8.79935 13.975 8.79935H15.5583C17.375 8.79935 18.3333 7.84102 18.3333 6.02435V4.44102C18.3333 2.62435 17.375 1.66602 15.5583 1.66602Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M15.5583 11.1914H13.975C12.1583 11.1914 11.2 12.1497 11.2 13.9664V15.5497C11.2 17.3664 12.1583 18.3247 13.975 18.3247H15.5583C17.375 18.3247 18.3333 17.3664 18.3333 15.5497V13.9664C18.3333 12.1497 17.375 11.1914 15.5583 11.1914Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    d: "M6.03333 11.1914H4.45C2.625 11.1914 1.66666 12.1497 1.66666 13.9664V15.5497C1.66666 17.3747 2.625 18.3331 4.44166 18.3331H6.025C7.84166 18.3331 8.8 17.3747 8.8 15.5581V13.9747C8.80833 12.1497 7.85 11.1914 6.03333 11.1914Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c476ff29d9f72c502884dd103de1c930.svg";
export { ForwardRef as ReactComponent };